import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { Col, Form, FormGroup, Row } from "react-bootstrap";
import moment from "moment";

import Button from "../../../../../components/common/button/Button";
import DatePicker2 from "../../../../../components/common/datepicker/DatePicker2";
import Input from "../../../../../components/common/input/Input";
import RichEditor from "../../../../../components/common/richEditor/RichEditor";

import {
  required,
  date,
  floatWithComma,
  comma
} from "../../../../../utils/forms/validators";

import * as invoiceActions from "../../../../../actions/invoice.actions";
import { INVOICE_UPDATE_FORM } from "../../../../../actions/invoice.actions";
import styles from "./EditInvoice.scss";

const rateFloat = floatWithComma("Please enter a valid number.");
const rateComma = comma("Please enter numeric characters only");
const dateVal = date("Please enter a valid Date.");

const richEditorValidation = (max, msg) => value => {
  const valueParse = value
    ? value.replace(/<[^>]*>/g, "").replace("&nbsp;", " ")
    : "";
  return valueParse.length > max && msg;
};

const additionalInformation = richEditorValidation(
  501,
  "Additional Information must be less than or equal to 2500 characters."
);

const validate = values => {
  const errors = {};

  if (
    values.billing_period_start &&
    values.billing_period_end &&
    moment(values.billing_period_end).isBefore(values.billing_period_start)
  ) {
    errors.billing_period_end = `The end date should be after the start date`;
  }

  return errors;
};

class EditInvoiceContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      method: null
    };

    this.handleStartDateChange = this.handleStartDateChange.bind(this);
  }

  componentDidMount() {
    this.props.invoiceActions.getInvoice(this.props.invoiceId);
  }

  handleStartDateChange(value) {
    this.setState({ startDate: moment(value) });
  }

  onSelect = value => {
    this.setState({
      filename: value
    });
  };

  render() {
    const { invoiceId, handleSubmit, submitting, valid } = this.props;

    return (
      <section className={styles.container}>
        <div className={styles.content}>
          <h2 className={styles.title}>Edit Invoice #{invoiceId}</h2>

          <Form onSubmit={handleSubmit}>
            <div className={styles.form}>
              <div className={styles.sectionTitle}>Quickbooks</div>
              <FormGroup>
                <Field
                  name="quickbooks_id"
                  type="text"
                  placeholder="Quickbooks ID"
                  component={Input}
                />
              </FormGroup>

              <div className={styles.divider} />
              <div className={styles.sectionTitle}>Amount</div>

              <FormGroup>
                <Field
                  name="amount"
                  type="text"
                  placeholder="Amount"
                  component={Input}
                  onChange={this.handleRateChange}
                  validate={[required, rateFloat, rateComma]}
                />
              </FormGroup>

              <div className={styles.divider} />
              <div className={styles.sectionTitle}>Billing Period</div>

              <Row>
                <Col xs={6}>
                  <Field
                    name="billing_period_start"
                    placeholder="Start"
                    component={DatePicker2}
                    onSelectDate={this.handleStartDateChange}
                    validate={dateVal}
                  />
                </Col>
                <Col xs={6}>
                  <Field
                    name="billing_period_end"
                    placeholder="End"
                    component={DatePicker2}
                    minDate={this.state.startDate || moment()}
                    validate={dateVal}
                  />
                </Col>
              </Row>

              <div className={styles.divider} />
              <div className={styles.sectionTitle}>Additional Information</div>

              <Field
                name="additional_information"
                component={RichEditor}
                placeHolder="Ex., Project ID, Project Code"
                maxLength={501}
                validate={additionalInformation}
              />

              <div className={styles.dividerDouble} />

              <div className={styles.CTAContainer}>
                <Button
                  isPrimary
                  type="submit"
                  size={"large"}
                  noMarginBottom
                  label="Submit Invoice"
                  isDisabled={!valid || submitting}
                />
              </div>
            </div>
          </Form>
        </div>
      </section>
    );
  }
}

EditInvoiceContainer = reduxForm({
  form: INVOICE_UPDATE_FORM,
  enableReinitialize: true,
  touchOnBlur: true,
  touchOnChange: true,
  validate
})(EditInvoiceContainer);

EditInvoiceContainer = connect(
  state => {
    const invoice = state.invoice.data.data;

    return {
      invoice,
      initialValues: {
        ...invoice,
        invoice_id: _.get(invoice, "id")
      }
    };
  },
  dispatch => ({
    invoiceActions: bindActionCreators(invoiceActions, dispatch)
  })
)(EditInvoiceContainer);

export default EditInvoiceContainer;



// WEBPACK FOOTER //
// ./src/routes/admin/invoice/edit/components/EditInvoice.js